// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__fBlnl","iconWithCounter":"styles_iconWithCounter__raI4M","counterForLabel":"styles_counterForLabel___FeqZ","counterForIcon":"styles_counterForIcon__GTkbz"};